import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.11454 21.8111C9.72135 22.3105 10.3529 22.7684 11 23.2136C11.5449 22.8389 12.0784 22.4552 12.5958 22.0451C11.7507 20.9178 11.25 19.5174 11.25 18C11.25 14.2721 14.2721 11.25 18 11.25C18.6504 11.25 19.2792 11.342 19.8743 11.5136C19.9559 11.0181 20 10.513 20 10C20 5.02944 15.9706 1 11 1C6.02944 1 2 5.02944 2 10C2 13.637 4.2179 16.8762 6.26196 19.112C7.30183 20.2494 8.33859 21.1725 9.11454 21.8111ZM11 13.25C9.20507 13.25 7.75 11.7949 7.75 10C7.75 8.20507 9.20507 6.75 11 6.75C12.7949 6.75 14.25 8.20507 14.25 10C14.25 11.7949 12.7949 13.25 11 13.25Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.9998 14.126C19.7147 14.31 20.3523 14.6867 20.8539 15.1975L22.0464 14.509L23.0464 16.241L21.8548 16.929C21.9493 17.2699 21.9998 17.629 21.9998 18C21.9998 18.371 21.9493 18.7301 21.8548 19.071L23.0464 19.759L22.0464 21.491L20.8539 20.8025C20.3523 21.3133 19.7147 21.69 18.9998 21.874V23.25H16.9998V21.874C16.2848 21.69 15.6472 21.3133 15.1457 20.8025L13.9531 21.491L12.9531 19.759L14.1447 19.071C14.0503 18.7301 13.9998 18.371 13.9998 18C13.9998 17.629 14.0503 17.2699 14.1447 16.929L12.9531 16.241L13.9531 14.509L15.1457 15.1975C15.6472 14.6867 16.2848 14.31 16.9998 14.126V12.75H18.9998V14.126ZM16.285 16.97L16.2485 17.0333C16.09 17.3198 15.9998 17.6494 15.9998 18C15.9998 18.3506 16.09 18.6802 16.2485 18.9667L16.285 19.03C16.6349 19.6112 17.2719 20 17.9998 20C18.7276 20 19.3646 19.6112 19.7145 19.03L19.751 18.9668C19.9095 18.6803 19.9998 18.3507 19.9998 18C19.9998 17.6493 19.9095 17.3197 19.751 17.0332L19.7145 16.97C19.3646 16.3888 18.7276 16 17.9998 16C17.2719 16 16.6349 16.3888 16.285 16.97Z"}}]};

const LocationSettingFilled = Vue.extend<IconProps>({
  name: 'LocationSettingFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'location-setting-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LocationSettingFilled;
